import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { safeMutate } from '../../../../utils/GeneralUtils';
import { getUId, propagateData } from '../utils';
import i18n from '../../../../utils/ChrI18n';
import ChrLink from '../../Utils/ChrLink';
import { DATE_STRING_OPTIONS } from '../../../../utils/Constants';
/*

props = {
  data: {
    value: <>,
    disabled: < true || false >,
    className: <>,
    locale: <>,
    skipFooter: < true || false >
  },
  uId: <uniqueIdentifier>,
  onChange: <handler>
}

*/

const ChrCalendar = (props) => {
  const formData = props.data;
  const myUId = getUId(props);
  const currentLocale = formData.locale || i18n.locale;
  const todayDateString = (new Date()).toLocaleDateString(currentLocale, {
    year: DATE_STRING_OPTIONS.NUMERIC,
    month: DATE_STRING_OPTIONS.LONG,
    day: DATE_STRING_OPTIONS.NUMERIC,
    weekday: DATE_STRING_OPTIONS.LONG
  });

  const onChangeHandler = (selectedDate) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = selectedDate;
    });
    propagateData("onChange", myUId, newFormData, props);
  };

  const clearSelectionHandler = (_event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = formData.defaultValue || undefined;
    });
    propagateData("onChange", myUId, newFormData, props);
  }

  const setToday = (_event) => {
    const newFormData = safeMutate(formData, draftData => {
      draftData.value = new Date();
    });
    propagateData("onChange", myUId, newFormData, props);
  }

  const canSetTodayFromFooter = () => {
    let date = new Date();
    return (!formData.minDate || formData.minDate.setHours(0, 0, 0, 0) <= date) && (!formData.maxDate || date <= formData.maxDate.setHours(23, 59, 59, 999))
  }

  const renderFooter = () => {
    const getClearSelectionLink = () => {
      if(formData.value){
        return (
          <div className='p-2'>
            <i className='fa-regular fa-undo m-r-xs'></i>
            <a className='cjs-calendar-clear-section' onClick={clearSelectionHandler}>{ i18n.t("datepicker.clear_selection") }</a>
          </div>
        )
      }
    }

    return (
      <div className='d-flex flex-column align-items-center border border-secondary border-top-0 gray-bg'>
        <div className='p-2'>
          <ChrLink onClick={ canSetTodayFromFooter() && setToday } className="cjs-calendar-today-link">{ todayDateString }</ChrLink>
        </div>
        { getClearSelectionLink() }
      </div>
    );
  }

  return (
    <div className={props.className}>
      <Calendar
        onChange={onChangeHandler}
        value={formData.value || undefined}
        minDate={formData.minDate}
        maxDate={formData.maxDate}
        locale={formData.locale}
      />
      { !formData.skipFooter && renderFooter() }
    </div>
  );
};

export default ChrCalendar;